import { gql } from '@apollo/client'

export const EMPLOYEE_CONTRACT_FIELDS = gql`
  fragment EmployeeContractFields on AdminEmployeeContract {
    id
    date
    department
    name
    position
    email
    idCardNumber
    candidateUploadUrl
    salary {
      value
      display
    }
    staff {
      id
      fullName
    }
    signedContracts {
      id
      filename
      contentType
      url
      thumbnailUrl
    }
    documents {
      id
      filename
      contentType
      url
      thumbnailUrl
    }
  }
`

export const EMPLOYEE_CONTRACTS_QUERY = gql`
  query EmployeeContracts($page: Int, $per: Int, $query: String, $department: EmployeeContractDepartmentEnum) {
    employeeContracts(page: $page, per: $per, query: $query, department: $department) {
      totalCount
      totalPages
      employeeContracts {
        ...EmployeeContractFields
      }
    }
  }
  ${EMPLOYEE_CONTRACT_FIELDS}
`

export const EMPLOYEE_CONTRACT_QUERY = gql`
  query EmployeeContract($id: ID!) {
    employeeContract(id: $id) {
      ...EmployeeContractFields
    }
  }
  ${EMPLOYEE_CONTRACT_FIELDS}
`

export const CREATE_EMPLOYEE_CONTRACT_MUTATION = gql`
  mutation CreateEmployeeContract(
    $date: ISO8601Date!,
    $department: EmployeeContractDepartmentEnum,
    $name: String!,
    $position: String!,
    $email: String!,
    $idCardNumber: String,
    $salary: Float!,
    $signedContractSignedIds: [String!],
    $documentSignedIds: [String!]
  ) {
    createEmployeeContract(
      date: $date,
      department: $department,
      name: $name,
      position: $position,
      email: $email,
      idCardNumber: $idCardNumber,
      salary: $salary,
      signedContractSignedIds: $signedContractSignedIds,
      documentSignedIds: $documentSignedIds
    ) {
      employeeContract {
        ...EmployeeContractFields
      }
      errors {
        key
        message
      }
    }
  }
  ${EMPLOYEE_CONTRACT_FIELDS}
`

export const UPDATE_EMPLOYEE_CONTRACT_MUTATION = gql`
  mutation UpdateEmployeeContract(
    $id: ID!,
    $date: ISO8601Date,
    $department: EmployeeContractDepartmentEnum,
    $name: String,
    $position: String,
    $email: String,
    $idCardNumber: String,
    $salary: Float,
    $signedContractSignedIds: [String!],
    $documentSignedIds: [String!]
  ) {
    updateEmployeeContract(
      id: $id,
      date: $date,
      department: $department,
      name: $name,
      position: $position,
      email: $email,
      idCardNumber: $idCardNumber,
      salary: $salary,
      signedContractSignedIds: $signedContractSignedIds,
      documentSignedIds: $documentSignedIds
    ) {
      employeeContract {
        ...EmployeeContractFields
      }
      errors {
        key
        message
      }
    }
  }
  ${EMPLOYEE_CONTRACT_FIELDS}
`

export const REMOVE_EMPLOYEE_CONTRACT_FILE_MUTATION = gql`
  mutation RemoveEmployeeContractFile($contractId: ID!, $attachmentId: ID!) {
    removeEmployeeContractFile(contractId: $contractId, attachmentId: $attachmentId) {
      removedId
      employeeContract {
        ...EmployeeContractFields
      }
      errors {
        key
        message
      }
    }
  }
  ${EMPLOYEE_CONTRACT_FIELDS}
`

export const SEND_EMPLOYEE_CONTRACT_ONBOARD_EMAIL_MUTATION = gql`
  mutation SendEmployeeContractOnboardEmail($id: ID!) {
    sendEmployeeContractOnboardEmail(id: $id) {
      sent
      errors {
        key
        message
      }
    }
  }
`

export const DELETE_UNATTACHED_BLOBS_MUTATION = gql`
  mutation DeleteEmployeeContractUploadBlobs($blobIds: [ID!]) {
    deleteActiveStorageBlob(blobIds: $blobIds) {
      deleteBlobIds
    }
  }
`

export const DEPARTMENTS = ['tech', 'scm', 'catman', 'operation', 'human_resource', 'accounting']

export const HR_ROLES = ['hr']

export const formatMutationErrors = (errors = []) => errors
  .map(({ key, message }) => (key ? `${key}: ${message}` : message))
  .join(', ')
